module.exports = __webpack_public_path__ + "img/services-alb1.d5c1a3f6.svg";